const LOG_PREFIX = "[SW]";

const SW_URL = "/service-worker.js";
const VERSION_URL = "/version.json";

const CHECK_INTERVAL_MS = 60_000;

const log = (...args) => console.log(LOG_PREFIX, ...args);
const warn = (...args) => console.warn(LOG_PREFIX, ...args);

const canAutoUpdate = () => process.env.REACT_APP_LOCAL_DB === "false";

const notifyUpdate = (version, message = "Dostępna jest nowa wersja aplikacji.") => {
  sessionStorage.setItem("isUpdateAvailable", "true");
  sessionStorage.setItem("updateType", "sw");

  window.dispatchEvent(
    new CustomEvent("app-update-available", {
      detail: {
        type: "sw",
        version,
        message,
      },
    })
  );
};

const fetchRemoteVersion = async () => {
  const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });

  if (!res.ok) return null;

  const data = await res.json().catch(() => null);
  return data?.version || null;
};

const checkForUpdate = async (registration) => {
  if (!canAutoUpdate()) return;

  try {
    if (registration?.waiting) {
      notifyUpdate(localStorage.getItem("APP_VERSION") || "unknown", "Masz gotową aktualizację (czeka na odświeżenie).");
      return;
    }
    const remoteVersion = await fetchRemoteVersion();
    if (!remoteVersion) return;

    const currentVersion = localStorage.getItem("APP_VERSION");
    if (!currentVersion) {
      localStorage.setItem("APP_VERSION", remoteVersion);
      return;
    }
    if (currentVersion !== remoteVersion) {
      localStorage.setItem("APP_VERSION", remoteVersion);

      notifyUpdate(remoteVersion, "Dostępna jest nowa wersja aplikacji.");
      if (typeof registration?.update === "function") {
        registration.update().catch(() => {});
      }
    }
  } catch (e) {
    warn("checkForUpdate error:", e?.message || e);
  }
};
export const skipWaiting = async () => {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;

    if (reg.waiting) {
      reg.waiting.postMessage({ type: "SKIP_WAITING" });
      return;
    }
    if (typeof reg.update === "function") {
      await reg.update().catch(() => {});
    }
  } catch (e) {
    warn("skipWaiting error:", e?.message || e);
  }
};
export const forceUpdate = () => {
  window.location.replace(window.location.pathname + window.location.search);
};

export function register() {
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;
  let reloading = false;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    sessionStorage.removeItem("isUpdateAvailable");
    sessionStorage.removeItem("updateType");

    window.location.replace(window.location.pathname + window.location.search);
  });

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(SW_URL, {
        updateViaCache: "none",
      });

      log("SW registered");
      if (registration.waiting && canAutoUpdate()) {
        notifyUpdate(localStorage.getItem("APP_VERSION") || "unknown", "Masz gotową aktualizację (czeka na odświeżenie).");
      }
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;

        worker.addEventListener("statechange", () => {
          if (
            worker.state === "installed" &&
            navigator.serviceWorker.controller &&
            canAutoUpdate()
          ) {
            setTimeout(() => {
              if (registration.waiting) {
                notifyUpdate(localStorage.getItem("APP_VERSION") || "unknown");
              }
            }, 300);
          }
        });
      });
      checkForUpdate(registration);
      setInterval(() => checkForUpdate(registration), CHECK_INTERVAL_MS);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState !== "visible") return;
        checkForUpdate(registration);
      });
    } catch (e) {
      warn("SW register error:", e?.message || e);
    }
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => {});
}

export const hasWaitingSW = async () => {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    return !!reg?.waiting;
  } catch {
    return false;
  }
};